export const lightBlueColor = "wtd";
export const lightGreenColor = "xtd";
export const lightYellowColor = "ytd";
export const lightOrangeColor = "ztd";
export const lightRedColor = "Atd";
export const lightPurpleColor = "Btd";
export const blueColor = "Ctd";
export const greenColor = "Dtd";
export const yellowColor = "Etd";
export const orangeColor = "Ftd";
export const redColor = "Gtd";
export const purpleColor = "Htd";
export const darkBlueColor = "Itd";
export const darkGreenColor = "Jtd";
export const darkYellowColor = "Ktd";
export const darkOrangeColor = "Ltd";
export const darkRedColor = "Mtd";
export const darkPurpleColor = "Ntd";
export const darkerBlueColor = "Otd";
export const darkerGreenColor = "Ptd";
export const darkerYellowColor = "Qtd";
export const darkerOrangeColor = "Rtd";
export const darkerRedColor = "Std";
export const darkerPurpleColor = "Ttd";
export const whiteColor = "Utd";
export const lightGrayColor = "Vtd";
export const grayColor = "Wtd";
export const darkGrayColor = "Xtd";
export const darkerGrayColor = "Ytd";
export const blackColor = "Ztd";
export const cyanColor = "_td";
export const magentaColor = "$td";
export const lightCyanColor = "aud";
export const lightMagentaColor = "bud";
export const noColor = "cud";
export const moreColor = "dud";
export default {lightBlueColor,lightGreenColor,lightYellowColor,lightOrangeColor,lightRedColor,lightPurpleColor,blueColor,greenColor,yellowColor,orangeColor,redColor,purpleColor,darkBlueColor,darkGreenColor,darkYellowColor,darkOrangeColor,darkRedColor,darkPurpleColor,darkerBlueColor,darkerGreenColor,darkerYellowColor,darkerOrangeColor,darkerRedColor,darkerPurpleColor,whiteColor,lightGrayColor,grayColor,darkGrayColor,darkerGrayColor,blackColor,cyanColor,magentaColor,lightCyanColor,lightMagentaColor,noColor,moreColor};